import gql from 'graphql-tag';
export default gql`
  mutation updateQuoteStageName($applicationId: String!, $stageName: String!) {
    updateQuoteStageName(applicationId: $applicationId, stageName: $stageName) {
      status
      message
    }
  }
`;
